// Reducers puros del ciclo de turno + help. Comparten shape entre App.tsx
// (docente) y LearnerEntry.tsx (alumno). Antes vivían duplicados en cada
// handler — 3 bugs históricos (help sin render, audio sin next_question,
// help mal wire-eado) por drift entre ambas copias.
//
// Cada función es pura y devuelve el nuevo chatHistory / GrantedHelpItem.
// Los callers los aplican dentro de `setPilot(p => ({ ...p, chatHistory: X }))`
// porque el shape de PilotState difiere ligeramente entre callers (App.tsx
// tiene `dictamen`, LearnerEntry usa `phase='done'`).
import type { ChatTurn, HelpType, Dim } from '../types';
import type { GrantedHelpItem } from '../components/InterviewPanel';

interface TurnResponseChatSlice {
  next_question?: string | null;
}

interface HelpResponseChatSlice {
  help_text: string;
  replacement_question: string | null;
  occurred_at: string;
}

interface HelpGrantSlice {
  penalty_pct: number;
  occurred_at: string;
}

export function buildTurnChatUpdate(
  prevHistory: ChatTurn[],
  resp: TurnResponseChatSlice,
  learnerTurn: ChatTurn,
): ChatTurn[] {
  const next: ChatTurn[] = [...prevHistory, learnerTurn];
  if (resp.next_question) {
    next.push({
      role: 'coach',
      text: resp.next_question,
      observed_at: new Date().toISOString(),
    });
  }
  return next;
}

// Reformulación: la nueva pregunta reemplaza semánticamente a la anterior;
// pushamos como segunda burbuja del coach para que el alumno la vea.
export function buildHelpChatUpdate(
  prevHistory: ChatTurn[],
  resp: HelpResponseChatSlice,
  helpType: HelpType,
): ChatTurn[] {
  const helpBubble: ChatTurn = {
    role: 'coach',
    text: resp.help_text,
    observed_at: resp.occurred_at,
    kind: 'help',
    helpType,
  };
  return resp.replacement_question
    ? [
        ...prevHistory,
        helpBubble,
        {
          role: 'coach',
          text: resp.replacement_question,
          observed_at: resp.occurred_at,
        },
      ]
    : [...prevHistory, helpBubble];
}

export function buildGrantedHelpEntry(
  resp: HelpGrantSlice,
  helpType: HelpType,
  currentDim: Dim | null,
): GrantedHelpItem {
  return {
    help_type: helpType,
    penalty_pct: resp.penalty_pct,
    at: resp.occurred_at,
    dim: currentDim,
  };
}
